import { createFileRoute } from '@tanstack/react-router'
import { listSearchSchema } from '@/lib/list-search-schema'
import InventoryMovements from '@/pages/InventoryMovements'

export const Route = createFileRoute('/_authenticated/inventory')({
  validateSearch: listSearchSchema,
  component: InventoryMovements,
})
